// extracted by mini-css-extract-plugin
module.exports = {"VerticalNav":"VerticalNav_VerticalNav__2fo2f","collapse":"VerticalNav_collapse__3-4ah"};